module.exports = "../../../../platform/assets/pageMainIcon/icon-riqi-4-yellow.svg";